import { useLoadStripe } from "../infra/useLoadStripe";
import { useIoContext } from "./IoContext";
import { jsx as _jsx } from "react/jsx-runtime";
const elementsOptions = {
  fonts: [{
    family: 'Lufga-Regular',
    src: 'url(https://storage.googleapis.com/anchor-cdn/fonts/Lufga-Regular.woff2)'
  }]
};
export default function StripeElementsProvider(props) {
  const {
    reactStripe: {
      Elements
    }
  } = useIoContext();
  const stripeObject = useLoadStripe();
  return /*#__PURE__*/_jsx(Elements, {
    stripe: stripeObject,
    options: elementsOptions,
    children: props.children
  });
}